// A month may order nothing (0), but must not be left blank or negative.
export const isValidMonthQuantity = (quantity) =>
  quantity !== "" && quantity != null && Number(quantity) >= 0

// Integer cents so the shares add back to `total` exactly.
export const evenShares = (total, n) => {
  const cents = Math.round(total * 100)
  const share = Math.floor(cents / n)
  return Array.from({ length: n }, (_, i) => (i === n - 1 ? cents - share * (n - 1) : share) / 100)
}

// Unsaved multiple-months order, same as BE PurchaseBudgetSplitService#spreadAmountsEvenly:
// lines sharing a key and spanning 2+ months split their total evenly, the remainder
// on the latest month. A null key (off-catalog, or center/item not picked yet) or a
// single-month group keeps each line's own amount.
// PO picker: line id → ids of the lines ticked with it. Money is even across a
// card's months, so a PO must take them together. The k-th line of each month
// belongs to the k-th card, so two cards of one item can still go to different POs.
export const linkedLineIds = (lines) => {
  const seen = new Map()
  const cards = new Map()
  lines.forEach((l) => {
    if (l.itemId == null || !l.fiscalMonth) return
    const card = [l.orderRequestId, l.itemId, l.centerId, l.requestType, l.replacedAssetCode].join("|")
    const nth = `${card}|${l.fiscalYear}-${l.fiscalMonth}`
    const k = seen.get(nth) || 0
    seen.set(nth, k + 1)
    const key = `${card}|${k}`
    cards.set(key, [...(cards.get(key) || []), l.id])
  })
  const linked = new Map()
  cards.forEach((ids) => {
    if (ids.length > 1) ids.forEach((id) => linked.set(id, ids))
  })
  return linked
}

export const spreadAmounts = (rows, keyOf, amountOf, monthOf) => {
  const groups = new Map()
  rows.forEach((row) => {
    const key = keyOf(row)
    if (key != null) groups.set(key, [...(groups.get(key) || []), row])
  })
  const amounts = new Map()
  groups.forEach((group) => {
    if (new Set(group.map(monthOf)).size < 2) return
    const byMonth = [...group].sort((a, b) => monthOf(a).localeCompare(monthOf(b)))
    const total = group.reduce((sum, row) => sum + amountOf(row), 0)
    evenShares(total, group.length).forEach((share, i) => amounts.set(byMonth[i], share))
  })
  return rows.map((row) => ({ ...row, amount: amounts.has(row) ? amounts.get(row) : amountOf(row) }))
}
